import React from 'react';

/**
 * Tabs — horizontal tab strip with a green underline on the active tab.
 * Optional numeric badge per tab.
 */
export function Tabs({ tabs = [], value, defaultValue, onChange, style = {}, ...rest }) {
  const first = defaultValue ?? (tabs[0] && (tabs[0].id ?? tabs[0]));
  const [internal, setInternal] = React.useState(first);
  const active = value ?? internal;
  const select = (id) => {
    if (value === undefined) setInternal(id);
    onChange && onChange(id);
  };
  return (
    <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid var(--border)', fontFamily: 'var(--font-sans)', ...style }} {...rest}>
      {tabs.map((t) => {
        const id = t.id ?? t;
        const label = t.label ?? t;
        const on = id === active;
        return (
          <button key={id} onClick={() => select(id)} style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '12px 16px', background: 'none', border: 'none', cursor: 'pointer',
            borderBottom: `2px solid ${on ? 'var(--brand-green)' : 'transparent'}`,
            marginBottom: -1, color: on ? 'var(--text-strong)' : 'var(--text-faint)',
            fontSize: 'var(--fs-body)', fontWeight: on ? 'var(--fw-bold)' : 'var(--fw-semibold)',
            transition: 'color .15s ease',
          }}>
            {label}
            {t.badge != null && (
              <span style={{
                minWidth: 20, height: 20, padding: '0 6px', borderRadius: 999,
                background: on ? 'var(--brand-green)' : 'var(--surface-2)',
                color: on ? '#fff' : 'var(--text-faint)',
                fontSize: 11, fontWeight: 800, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              }}>{t.badge}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
